export default "__VITE_ASSET__BmENcRg5__"